import { toRefs, reactive } from 'vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';

// initialize firebase, this is directly from the firebase documentation
// regarding getting started for the web
if (firebase.apps.length === 0) {
  const firebaseConfig = {
    apiKey: "AIzaSyDBE4R6TINuot_5nX8pnD2QLtHp0tLnkCI",
    authDomain: "zoospol-63d65.firebaseapp.com",
    projectId: "zoospol-63d65",
    storageBucket: "zoospol-63d65.firebasestorage.app",
    messagingSenderId: "1066695266306",
    appId: "1:1066695266306:web:212d0342c5f4a5fe18571b",
    measurementId: "G-ZMBQFRD51K"
  };
  console.log("Init firebase")
  firebase.initializeApp(firebaseConfig);
  console.log("Initiated firebase")
}

export default function() {
  let state = reactive({
    user: null,
    loading: true,
    error: null
  });

  firebase.auth().onAuthStateChanged(_user => {
    console.log("onAuthStateChanged")
    if (_user) {
      state.user = _user;
    } else {
      state.user = null;
    }
    state.loading = false;
  });

  return {
    ...toRefs(state)
  };
}
